import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { MetricData } from '../data/mockData';
interface MetricCardProps {
  metric: MetricData;
}
export function MetricCard({
  metric
}: MetricCardProps) {
  const isPositive = metric.trend === 'up';
  const isNeutral = metric.trend === 'neutral';
  const isNegative = metric.trend === 'down';
  const trendColor = isPositive ? 'text-emerald-400' : isNegative ? 'text-red-400' : 'text-slate-400';
  const sparklineColor = isPositive ? '#34d399' : isNegative ? '#f87171' : '#94a3b8';
  return <div className="bg-slate-800/80 border border-slate-700/50 rounded-xl p-5 hover:bg-slate-800 hover:border-slate-600 transition-all duration-200 shadow-lg group relative overflow-hidden" data-id="element-99">
      {/* Subtle top glow based on trend */}
      <div className={`absolute top-0 left-0 w-full h-0.5 opacity-50 group-hover:opacity-100 transition-opacity ${isPositive ? 'bg-emerald-500' : isNegative ? 'bg-red-500' : 'bg-slate-500'}`} data-id="element-100" />

      <div className="flex justify-between items-start mb-2" data-id="element-101">
        <h3 className="text-slate-400 text-sm font-medium" data-id="element-102">{metric.name}</h3>
        <div className={`flex items-center text-xs font-semibold ${trendColor} bg-slate-900/50 px-2 py-1 rounded-md`} data-id="element-103">
          {isPositive && <TrendingUp className="w-3 h-3 mr-1" data-id="element-104" />}
          {isNegative && <TrendingDown className="w-3 h-3 mr-1" data-id="element-105" />}
          {isNeutral && <Minus className="w-3 h-3 mr-1" data-id="element-106" />}
          {metric.trendValue}
        </div>
      </div>

      <div className="flex items-end justify-between mt-4" data-id="element-107">
        <div className="text-3xl font-bold text-white tracking-tight" data-id="element-108">
          {metric.value}
        </div>

        <div className="w-20 h-10 opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-109">
          <ResponsiveContainer width="100%" height="100%" data-id="element-110">
            <LineChart data={metric.sparklineData} data-id="element-111">
              <Line type="monotone" dataKey="value" stroke={sparklineColor} strokeWidth={2} dot={false} isAnimationActive={false} data-id="element-112" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>;
}